/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleHalf = createReactComponent("circle-half", "IconCircleHalf", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 3v18", key: "svg-1" }]
]);

export { IconCircleHalf as default };
//# sourceMappingURL=IconCircleHalf.js.map
